import { Component, OnInit } from '@angular/core';
import { API } from '../../../../services/api/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../../services/util.service';
import { ColorPickerService } from '../../../../services/color-picker.service';

@Component({
  selector: 'sb-page-time-type-edit',
  templateUrl: './time-type-edit.component.html',
  styleUrls: ['./time-type-edit.component.scss'],
  standalone: false,
})
export class TimeTypeEditComponent implements OnInit {
  timeTypeID: number;
  loading: boolean;
  timeType: any; // TimeTypeDTO;

  form = new FormGroup({
    Name: new FormControl('', [Validators.required]),
    Description: new FormControl(''),
    Color: new FormControl('', [Validators.required]),
  });

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public colorService: ColorPickerService
  ) {
    this.loading = true;
    this.timeTypeID = null;
    this.timeType = null;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.timeTypeID = params.timeTypeID ? +params.timeTypeID : null;
      this.setupView();
      this.registerFormChangesListener();
    });
  }

  private registerFormChangesListener() {
    this.Color.valueChanges.subscribe(value => {
      if (value?.length === 6) {
        this.timeType.color = value;
      }
    });
  }

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  get Color() {
    return this.form.get('Color');
  }

  private setupView() {
    if (this.timeTypeID !== null && this.timeTypeID !== undefined) {
      /*
      timetypes missing
      this.api.shared_TimeType_getTimeType(this.timeTypeID).subscribe((timeTypes: TimeTypeDTO) => {
        this.timeType = timeTypes;
        this.updateFromDTO();
        this.unsetLoading();
      });
       */
    } else {
      this.timeType = {}; // new TimeTypeDTO();
      this.timeType.color = 'FFFFFF';
      this.unsetLoading();
    }
  }

  private updateFromDTO() {
    if (this.timeType) {
      this.Name.setValue(this.timeType.name);
      this.Name.markAsTouched();
      this.Description.setValue(this.timeType.description);
      this.Description.markAsTouched();
      this.Color.setValue(this.timeType.color);
      this.Color.markAsTouched();
    }
  }

  private updateDTOFromForm() {
    if (this.timeType) {
      this.timeType.name = this.Name.value;
      this.timeType.description = this.Description.value;
    }
  }

  private unsetLoading() {
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  cancel() {
    this.returnToTimeTypesPage();
  }

  returnToTimeTypesPage() {
    // this.util.returnToNavigation(this.util.RoutingID.timeTypes);
  }

  submit() {
    this.loading = true;
    this.updateDTOFromForm();
    /*
    timetypes missing
    if (this.timeTypeID) {
      this.api.shared_TimeType_editTimeType(this.timeType), finalize(() => {this.loading = false;}).subscribe(() => {
        this.returnToTimeTypesPage();
      });
    } else {
      this.api.shared_TimeType_createTimeType(this.timeType), finalize(() => {this.loading = false;}).subscribe(() => {
        this.returnToTimeTypesPage();
      });
    }

     */
  }

  setColor($event) {
    if ($event) {
      const temp = $event.split('#');
      this.timeType.color = temp[temp.length - 1];
      this.Color.setValue(this.timeType.color);
    }
  }
}
